import { RegisterTenantRequest, TenantSubscriptionPlanResponse } from '@src/models/api'

export const authParseTariff = (tariff: string): Pick<RegisterTenantRequest, 'tariff' | 'months'> => {
    const [plan, months] = tariff.split('_')
    return {
        tariff: plan === 'basic' ? TenantSubscriptionPlanResponse.Basic : TenantSubscriptionPlanResponse.Pro,
        months: Number(months)
    }
}
